import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, userStatus } = useAuth();
  const [adminChecked, setAdminChecked] = useState(false);
  const [isAdmin,      setIsAdmin]      = useState(false);

  useEffect(() => {
    if (!user) { setAdminChecked(true); return; }
    // Always resolve the admin claim so we can correctly bypass both the
    // email-verification check and the approval check for admin accounts.
    user.getIdTokenResult()
      .then((result) => setIsAdmin(result.claims.admin === true))
      .catch(() => {})
      .finally(() => setAdminChecked(true));
  }, [user]);

  if (!user) return <Navigate to="/login" replace />;
  if (!adminChecked) return null;

  // Gate 1 — email verification (admins bypass)
  if (!user.emailVerified && !isAdmin) return <Navigate to="/login" replace />;

  // Gate 2 — admin approval (admins bypass; null status = admin account with no users doc)
  if (userStatus !== "approved" && !isAdmin) return <Navigate to="/pending-approval" replace />;

  return children;
};

export default ProtectedRoute;
